import api from "./api";

export async function togglePodcastBookmark(payload = {}) {
  const response = await api.post("/audio-podcast/bookmark", payload);
  return { payload: response?.data?.dataset?.data || {}, meta: response?.data || {} };
}

export async function togglePodcastLike(payload = {}) {
  const response = await api.post("/audio-podcast/like", payload);
  return { payload: response?.data?.dataset?.data || {}, meta: response?.data || {} };
}
